import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { faMapMarkerAlt, faNotesMedical, faStar, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { NavController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-cancelled',
    templateUrl: './application-cancelled.component.html',
    styleUrls: ['./application-cancelled.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ApplicationCancelledComponent implements OnInit {
    @Input() application: any;
    @Input() currentState: any;

    faMapMarkerAlt = faMapMarkerAlt;
    faNotesMedical = faNotesMedical;
    faStar = faStar;
    faTimesCircle = faTimesCircle;

    constructor(private navCtrl: NavController, public toolService: ToolService) {}

    ngOnInit() {
        /* empty */
    }

    new = () => {
        this.navCtrl.navigateRoot(['/search']);
    };
}
